module.exports = ".ui-widget-content a\r\n{\r\n    color:white !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/report-management/reports/reports.component.css
// module id = ./src/app/admin/report-management/reports/reports.component.css
// module chunks = main